<style scoped>
.time-buttons {
  margin-left: 0;
}
</style>

<template>
  <div>
    <div class="form-group row">
      <col-label>Online nach Rundmail (in Minuten)</col-label>
      <div class="col-8">
        <input
          type="number"
          class="form-control"
          v-model="fakeOnlineTimeCircularMail"
        />
        <div class="row time-buttons">
          <button
            class="btn btn-danger"
            @click="setFakeOnlineTime('CircularMail', 0)"
          >
            Nicht online
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('CircularMail', 15)"
          >
            15 Minuten
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('CircularMail', 60)"
          >
            1 Stunde
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('CircularMail', 180)"
          >
            3 Stunden
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="form-group row">
      <col-label>Online nach automatischer Nachricht (in Minuten)</col-label>
      <div class="col-8">
        <input
          type="number"
          class="form-control"
          v-model="fakeOnlineTimeAutomaticMessage"
        />
        <div class="row time-buttons">
          <button
            class="btn btn-danger"
            @click="setFakeOnlineTime('AutomaticMessage', 0)"
          >
            Nicht online
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('AutomaticMessage', 15)"
          >
            15 Minuten
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('AutomaticMessage', 60)"
          >
            1 Stunde
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('AutomaticMessage', 180)"
          >
            3 Stunden
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="form-group row">
      <col-label>Online nach Werbung (in Minuten)</col-label>
      <div class="col-8">
        <input
          type="number"
          class="form-control"
          v-model="fakeOnlineTimeAffiliate"
        />
        <div class="row time-buttons">
          <button
            class="btn btn-danger"
            @click="setFakeOnlineTime('Affiliate', 0)"
          >
            Nicht online
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('Affiliate', 15)"
          >
            15 Minuten
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('Affiliate', 60)"
          >
            1 Stunde
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('Affiliate', 180)"
          >
            3 Stunden
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="form-group row">
      <col-label>Online nach Nutzung im Modpanel (in Minuten)</col-label>
      <div class="col-8">
        <input
          type="number"
          class="form-control"
          v-model="fakeOnlineTimeModpanel"
        />
        <div class="row time-buttons">
          <button
            class="btn btn-danger"
            @click="setFakeOnlineTime('Modpanel', 0)"
          >
            Nicht online
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('Modpanel', 15)"
          >
            15 Minuten
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('Modpanel', 60)"
          >
            1 Stunde
          </button>
          <button
            class="btn btn-primary"
            @click="setFakeOnlineTime('Modpanel', 180)"
          >
            3 Stunden
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="form-group">
      <button @click="persist()" class="btn btn-primary">Speichern</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fakeOnlineTimeCircularMail: 0,
      fakeOnlineTimeAutomaticMessage: 0,
      fakeOnlineTimeAffiliate: 0,
      fakeOnlineTimeModpanel: 0
    };
  },
  created() {
    this.$store.dispatch("setting/all").then(() => {
      const settings = this.$store.getters["setting/all"];
      this.fakeOnlineTimeCircularMail = settings.fakeOnlineTimeCircularMail;
      this.fakeOnlineTimeAutomaticMessage =
        settings.fakeOnlineTimeAutomaticMessage;
      this.fakeOnlineTimeAffiliate = settings.fakeOnlineTimeAffiliate;
      this.fakeOnlineTimeModpanel = settings.fakeOnlineTimeModpanel;
    });
  },
  methods: {
    setFakeOnlineTime($action, $time) {
      this["fakeOnlineTime" + $action] = $time;
    },
    persist() {
      const data = Object.assign(
        {},
        {
          fakeOnlineTimeCircularMail: this.fakeOnlineTimeCircularMail,
          fakeOnlineTimeAutomaticMessage: this.fakeOnlineTimeAutomaticMessage,
          fakeOnlineTimeAffiliate: this.fakeOnlineTimeAffiliate,
          fakeOnlineTimeModpanel: this.fakeOnlineTimeModpanel
        }
      );
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  }
};
</script>
